import { IInfrastructure } from '../utils';

export const findGeoObjectDatum = (geoObjectId: string, regularInfrastructureByYear: Map<number, IInfrastructure>) => {
  const yearInfrastructures = Array.from(regularInfrastructureByYear.values());

  for (const { geoObjectsData } of yearInfrastructures) {
    for (const datum of geoObjectsData) {
      if (datum.geoObject.options.id === geoObjectId) {
        return datum;
      }
    }
  }

  return null;
};
